import React, {createContext, useContext, useState} from 'react';

const AMLContext = createContext();

export function AMLProvider({children}) {
  const [searchDetails, setSearchDetails] = useState(null);
  const [customerName, setCustomerName] = useState('Unknown');

  return (
    <AMLContext.Provider
      value={{
        searchDetails,
        setSearchDetails,
        customerName,
        setCustomerName,
      }}
    >
      {children}
    </AMLContext.Provider>
  );
}

export function useAMLContext() {
  const context = useContext(AMLContext);
  if (!context) {
    throw new Error('useAMLContext must be used within an AMLProvider');
  }
  return context;
}
